module.exports = __webpack_public_path__ + "07ed46b70a5e91d2d6a3acfdd6a466fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/closeG.png
// module id = 753
// module chunks = 0